module.exports = __webpack_public_path__ + "static/media/BS_F_Embroidery_Bicocca_DKGrey_White.b79415dd.png";